<template>
    <v-navigation-drawer app v-model="drawer">
        <v-list-item>
            <v-list-item-content>
                <router-link to="/">
                    <v-list-item-title class="title">
                        TC Deliveries
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        CMS
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                        <small>v{{ $store.state.app.version }}</small>
                    </v-list-item-subtitle>
                </router-link>
            </v-list-item-content>
        </v-list-item>
        <v-divider />
        <navbar-links
            v-if="isRestaurateur"
            v-bind:links="restOrderLinks"
            header="Orders"
        />
        <template v-if="isOperator">
            <navbar-links
                v-bind:links="opRestaurantOrderLinks"
                header="Restaurant orders"
            />
            <navbar-links v-bind:links="opJobOrderLinks" header="Job orders" />
            <navbar-links v-bind:links="opCourierLinks" header="Couriers" />
            <navbar-links
                v-bind:links="opRestaurantLinks"
                header="Restaurants"
            />
            <navbar-links v-bind:links="opLocationLinks" header="Locations" />
        </template>
        <navbar-links v-bind:links="accountLinks" header="Account" />
    </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
    components: {
        'navbar-links': () => import('@/components/NavbarLinks.vue')
    },
    data() {
        return {
            restOrderLinks: [
                {
                    name: 'rest-order-list',
                    icon: 'mdi-silverware-variant',
                    text: 'All orders'
                },
                {
                    name: 'rest-order-create',
                    icon: 'mdi-file-plus',
                    text: 'New order'
                },
                {
                    name: 'rest-settlements',
                    icon: 'mdi-format-list-checks',
                    text: 'Settlements'
                }
            ],
            opRestaurantOrderLinks: [
                {
                    name: 'op-restaurantorder-list',
                    icon: 'mdi-silverware-variant',
                    text: 'Restaurant orders'
                },
                {
                    name: 'op-restaurantorder-create',
                    icon: 'mdi-file-plus',
                    text: 'New restaurant order'
                }
            ],
            opJobOrderLinks: [
                {
                    name: 'op-joborder-list',
                    icon: 'mdi-near-me',
                    text: 'Job orders'
                },
                {
                    name: 'op-joborder-create',
                    icon: 'mdi-file-plus',
                    text: 'New job order'
                }
            ],
            opCourierLinks: [
                {
                    name: 'op-courierinfo-list',
                    icon: 'mdi-motorbike',
                    text: 'All couriers'
                },
                {
                    name: 'op-courierinfo-create',
                    icon: 'mdi-account-plus',
                    text: 'New courier'
                }
            ],
            opRestaurantLinks: [
                {
                    name: 'op-restaurant-list',
                    icon: 'mdi-format-list-bulleted',
                    text: 'All restaurants'
                },
                {
                    name: 'op-restaurant-create',
                    icon: 'mdi-file-plus',
                    text: 'New restaurant'
                }
            ],
            opLocationLinks: [
                {
                    name: 'op-location-list',
                    icon: 'mdi-map-marker',
                    text: 'Locations'
                }
            ],
            accountLinks: [
                {
                    name: 'password-change',
                    icon: 'mdi-key',
                    text: 'Change password'
                }
            ]
        };
    },
    computed: {
        ...mapGetters({
            isOperator: 'auth/isOperator',
            isRestaurateur: 'auth/isRestaurateur'
        }),
        drawer: {
            get() {
                return this.$store.state.app.drawer;
            },
            set(value) {
                this.setDrawer(value);
            }
        }
    },
    methods: {
        ...mapMutations({
            setDrawer: 'app/SET_DRAWER'
        })
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
